var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnifePink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ff1493;} .st1{fill:#ff1493;} .st2{fill:#ffffff;} .st3{fill:#FFFFFF;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.1,210.2L346.7,85.6c28.9-28.9,83-51.8,132.3-42.9l-39.4,31.9l-5.7,38.8L248,299.2l-62.7-62.7l31.5-31.5 L222.1,210.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 110,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -279.6607 171.043)",
    width: 15.2,
    x: 59,
    y: 368.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "193.6,338.9 161.3,306.6 150.8,317.1 183.1,349.4 151,381.5 118.7,349.2 108.2,359.7 140.5,392 103.9,428.6 61.1,385.8 76.5,370.5 108.8,402.8 119.3,392.3 87,360 119,327.9 151.3,360.2 161.8,349.7 129.5,317.4 166.1,280.8 208.9,323.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "236.9,330.6 229.9,323.6 229.9,323.6 166.1,259.8 166.1,259.8 159.1,252.8 169.9,242 247.7,319.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M497.5,32c-26.2-8.3-56.4-8.1-87.2,0.8c-28.8,8.3-55.1,23.3-74.1,42.3L211.6,199.7l10.5,10.5L346.7,85.6 c28.9-28.9,83-51.8,132.3-42.9l-39.4,31.9l-5.7,38.8L248,299.2L169.9,221l-31.8,31.8l17.5,17.5l-105,105l-17.5-17.5L1.3,389.6 l98.8,98.8l31.8-31.8l-17.5-17.5l105-105l17.5,17.5l31.8-31.8l-10.2-10.2l189.3-189.3l5.6-37.9l57.2-46.3L497.5,32z M100.2,467.4 l-77.8-77.8l10.8-10.8l77.8,77.8L100.2,467.4z M208.9,323.6l-15.3,15.3l-32.3-32.3l-10.5,10.5l32.3,32.3l-32,32l-32.3-32.3 l-10.5,10.5l32.3,32.3l-36.6,36.6l-42.8-42.8l15.3-15.3l32.3,32.3l10.5-10.5L87,360l32-32l32.3,32.3l10.5-10.5l-32.3-32.3 l36.6-36.6L208.9,323.6z M247.7,319.8l-10.8,10.8l-7-7v0l-63.8-63.8l0,0l-7-7l10.8-10.8L247.7,319.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 14.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -94.0666 334.3636)",
    width: 66.6,
    x: 323.3,
    y: 273.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 14.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -133.3784 318.1014)",
    width: 14.9,
    x: 309.8,
    y: 312.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 14.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 47.7983 220.2345)",
    width: 66.6,
    x: 256.4,
    y: 45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 14.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 8.4848 203.9483)",
    width: 14.8,
    x: 243,
    y: 84.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M418.4,78.3l-4.6-14.1c-21.5,7-41.8,19-55.6,32.9l-59,59l10.5,10.5l59-59C380.9,95.3,399.1,84.7,418.4,78.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 14.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -40.7325 255.9598)",
    width: 14.9,
    x: 281.2,
    y: 169.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 14.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -97.1576 206.8085)",
    width: 14.9,
    x: 193.7,
    y: 213.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnifePink);
export default __webpack_public_path__ + "static/media/knife-pink.b17899c06113f5f960408e24748cc930.svg";
export { ForwardRef as ReactComponent };